export const BUTTON_TEST_IDS = {
  BUTTON_TEST: 'button-test'
};
